import { Box, Link, Stack } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { TablePagination } from '@mui/material';
import { SourcedCandidateQueryItem } from 'modules/sourcing-external/types/SourcedCandidateQueryItem';
import { SourcingExternalTextBlock } from 'modules/sourcing-external/components/SourcingExternalTextBlock';

export const SourcingExternalInviteCandidateDrawer: React.FC<{
  row: SourcedCandidateQueryItem;
  currentIndex: number;
  total: number;
  onNext?: () => void;
  onPrev?: () => void;
}> = ({ row, currentIndex, total, onNext, onPrev }) => {
  return (
    <Stack gap="40px" pt="10px">
      <Link
        href={row.linkedInProfileUrl ?? ''}
        target="_blank"
        sx={{
          p: 0,
          gap: '8px',
          w: 'fit',
          color: 'primary.main',
          fontWeight: 500,
          textDecoration: 'none',
          alignItems: 'center',
          display: 'flex'
        }}
      >
        View LinkedIn profile <OpenInNewIcon />
      </Link>
      <Stack flexDirection="row" alignItems="center" width="100%">
        <Box flex={1} />
        <TablePagination
          component="div"
          sx={{
            width: '400px'
          }}
          labelDisplayedRows={({ from, count }) => `${from} of ${count}`}
          count={total}
          page={currentIndex}
          rowsPerPage={1}
          rowsPerPageOptions={[]}
          onPageChange={(_, page) => {
            if (page === currentIndex + 1) {
              onNext?.();
            } else if (page === currentIndex - 1) {
              onPrev?.();
            }
          }}
        />
      </Stack>
      <SourcingExternalTextBlock
        title="Experience"
        items={row.experience || []}
      />
      <SourcingExternalTextBlock title="Skills" items={row.skills || []} />
      <SourcingExternalTextBlock
        title="Education"
        items={row.education || []}
      />
    </Stack>
  );
};
